import { Dialog } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { Connection } from '@domain/connection/models/Connection';
import { ClientType } from '@domain/connection/models/Connector';
import BolCredentialsForm from '../../bol/components/BolCredentialsForm';
import MontaCredentialsForm from '../../monta/components/MontaCredentialsForm';
import ProductFlowCredentialsForm from '../../product_flow/components/ProductFlowCredentialsForm';
import WooCommerceCredentialsForm from '@features/connections/woocommerce/components/WooCommerceCredentialsForm';
import ShopifyConnectForm from '../../shopify/components/ShopifyConnectForm';
import AmazonCredentialsForm from '../../amazon/components/AmazonCredentialsForm';
import ChannelDockCredentialsForm from '../../channeldock/components/ChannelDockCredentialsForm';

interface ReconnectConnectionDialogProps {
  connection: Connection | null;
  open: boolean;
  onClose: () => void;
}

const ReconnectConnectionDialog = ({
  connection,
  open,
  onClose,
}: ReconnectConnectionDialogProps) => {
  const queryClient = useQueryClient();

  const handleReconnected = () => {
    queryClient.invalidateQueries({ queryKey: ['connections'] });
    queryClient.invalidateQueries({ queryKey: ['tasks'] });
    onClose();
  };

  if (!connection) {
    return null;
  }

  const type = connection.connector.type;
  let form = null;

  if (type === ClientType.BOL) {
    form = (
      <BolCredentialsForm
        reconnectConnectionId={connection.id}
        onNewConnection={handleReconnected}
        onClose={onClose}
      />
    );
  } else if (type === ClientType.MONTA) {
    form = (
      <MontaCredentialsForm
        reconnectConnectionId={connection.id}
        onNewConnection={handleReconnected}
        onClose={onClose}
      />
    );
  } else if (type === ClientType.PRODUCT_FLOW) {
    form = (
      <ProductFlowCredentialsForm
        reconnectConnectionId={connection.id}
        onNewConnection={handleReconnected}
        onClose={onClose}
      />
    );
  } else if (type === ClientType.WOOCOMMERCE) {
    form = (
      <WooCommerceCredentialsForm
        reconnectConnectionId={connection.id}
        onNewConnection={handleReconnected}
        onClose={onClose}
      />
    );
  } else if (type === ClientType.SHOPIFY) {
    form = (
      <ShopifyConnectForm connectionId={connection.id} onClose={onClose} />
    );
  } else if (type === ClientType.AMAZON) {
    form = (
      <AmazonCredentialsForm
        reconnectConnectionId={connection.id}
        onNewConnection={handleReconnected}
        onClose={onClose}
      />
    );
  } else if (type === ClientType.CHANNELDOCK) {
    form = (
      <ChannelDockCredentialsForm
        reconnectConnectionId={connection.id}
        onNewConnection={handleReconnected}
        onClose={onClose}
      />
    );
  }

  if (!form) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {form}
    </Dialog>
  );
};

export default ReconnectConnectionDialog;
